import styled, { css } from 'styled-components';
import { colors } from '@omilia/theme';

const centerContentWhenNotOk = ({ hasError, isLoaded }) => {
  return (
    (hasError || !isLoaded) &&
    css`
      align-items: center;
      display: flex;
      justify-content: center;
    `
  );
};

export const SChatContentContainer = styled.div<{
  hasError: boolean;
  isLoaded: boolean;
  backgroundColor?: string;
}>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colors.COLOR_WHITE};
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 27px 16px;
  box-sizing: border-box;

  ${centerContentWhenNotOk}
`;

export const SChatOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  flex: 1;
  height: 404px;
  overflow-y: hidden;
  position: relative;
`;
